//主要定义一些常量变量
import pkg from '@/../package.json'
export const APP_NAME = pkg.name
